<template>
  <div class="journal-top clearfix">
    <!-- <div class="search-wrapper">
      <img class="search-btn" src="/static/img/search.png" alt>
      <input class="search-input" type="text" placeholder="关键字搜索">
    </div> -->
    <div class="jonaral-left">

     <!-- <search></search> -->
    </div>
    <div class="nav-wrapper">
      <span>当前位置：</span>
      <span class="active" @click="toPage('/journal')">期刊</span>
      <span class="padd">&#62;</span>
      <span>{{seconTitle}}</span>
    </div>
  </div>
</template>
<script>
import search from "@/components/views/common/search.vue";
export default {
  data() {
    return {};
  },
  props: ["seconTitle"],
  methods: {
    toPage(url) {
      this.$router.push(url);
    }
  },
    components: {
    search
  }
};
</script>

<style scoped>
.nav-wrapper {
  font-size: 0;
  margin-bottom: 30px;
}
.nav-wrapper span {
  font-size: 16px;
  color: #212121;
  line-height: 40px;
}
.active {
  color: #194eb0 !important;
  cursor: pointer;
}
.padd {
  padding: 0 4px;
}
.jonaral-left {
  width: 310px;
  margin-right: 30px;
  float: left;
}

</style>




// WEBPACK FOOTER //
// src/components/views/Journal/commonTop.vue